import api from "services/axiosInstance";
import { ITrack } from "types/musicData";

export const UploadLyrics = async (songId: string, track: ITrack) => {
  try {
    if (track.lyrics)
      await api.post("/lyrics", {
        songId,
        basicLyrics: track.lyrics.text
      });
  } catch (err) {
    throw err;
  }
};
